var map = {
	"./image1.png": 13071,
	"./image10.png": 58623,
	"./image2.png": 91604,
	"./image3.png": 12733,
	"./image4.png": 51010,
	"./image5.png": 41515,
	"./image6.png": 27696,
	"./image7.png": 33945,
	"./image8.png": 44558,
	"./image9.png": 44055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6065;